<template>
  <div class="chart-iframe">
    <!-- Loading overlay (only when actually loading a URL) -->
    <transition name="fade">
      <div v-if="loading && url" class="chart-iframe__loading">
        <div class="chart-iframe__skeleton">
          <div class="chart-iframe__skeleton-shimmer" />
          <div class="chart-iframe__skeleton-text">
            <span>{{ loadingText }}</span>
          </div>
        </div>
      </div>
    </transition>

    <!-- Empty state when no URL -->
    <div v-if="!url" class="chart-iframe__empty">
      <svg viewBox="0 0 24 24" width="40" height="40" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" style="opacity:0.25; margin-bottom:12px">
        <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
        <line x1="3" y1="9" x2="21" y2="9" />
        <line x1="9" y1="21" x2="9" y2="9" />
      </svg>
      <span>{{ emptyText }}</span>
    </div>

    <!-- Iframe -->
    <iframe
      v-if="url"
      ref="embedIframe"
      :src="url"
      class="chart-iframe__frame"
      frameborder="0"
      tabindex="-1"
      allowfullscreen
      allow="clipboard-write"
      @load="$emit('loaded')"
    />
  </div>
</template>

<script>
export default {
  name: 'ChartIframe',

  props: {
    url: { type: String, default: '' },
    loading: { type: Boolean, default: true },
    loadingText: { type: String, default: 'Cargando...' },
    emptyText: { type: String, default: 'Selecciona un modelo y gráfica para comenzar.' },
  },
}
</script>

<style scoped>
.chart-iframe {
  position: relative;
  flex: 1 1 auto;
  min-height: 200px;
  overflow: hidden;
  height: 100%;
}

.chart-iframe__frame {
  width: 100%;
  height: 100%;
  border: none;
  display: block;
}

.chart-iframe__loading {
  position: absolute;
  inset: 0;
  z-index: 5;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(14, 17, 23, 0.85);
  backdrop-filter: blur(4px);
}

.chart-iframe__skeleton {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}

.chart-iframe__skeleton-shimmer {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  border: 3px solid rgba(0, 104, 201, 0.25);
  border-top-color: #0068c9;
  animation: chart-iframe-spin 0.8s linear infinite;
}

.chart-iframe__skeleton-text {
  font-size: 0.85rem;
  color: rgba(255, 255, 255, 0.45);
  letter-spacing: 0.04em;
}

.chart-iframe__empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  min-height: 200px;
  font-size: 0.9rem;
  color: rgba(255, 255, 255, 0.35);
}

@keyframes chart-iframe-spin {
  to { transform: rotate(360deg); }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
